// Angular
import { AsyncPipe } from '@angular/common';
import {
  Component,
  OnInit,
  inject,
  DOCUMENT,
  ChangeDetectionStrategy,
} from '@angular/core';
// Transloco
import { TranslocoService, TranslocoDirective } from '@jsverse/transloco';
// Rxjs
import { Observable } from 'rxjs';
// App Init Service
import { AppInitLoaderService } from '@app/app-init-loader.service';

@Component({
  selector: 'app-seller-own-stock-banner',
  templateUrl: './seller-own-stock-banner.component.html',
  styleUrls: ['./seller-own-stock-banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [TranslocoDirective, AsyncPipe],
})
export class SellerOwnStockBannerComponent implements OnInit {
  // Private
  private readonly appInitLoaderService = inject(AppInitLoaderService);
  private readonly translocoService = inject(TranslocoService);
  private document = inject<Document>(DOCUMENT);

  // Public
  seller: any;
  domainWithoutCid: string;
  languageChange$: Observable<string>;

  ngOnInit(): void {
    // Get Company Info
    this.seller = this.appInitLoaderService.company;

    // Get Parent group link
    this.domainWithoutCid = this.appInitLoaderService.domainWithoutCid;

    // Get Current live language
    this.languageChange$ = this.translocoService.langChanges$;
  }

  /**
   * On exit own stock page
   * @memberof SellerOwnStockBannerComponent
   */
  onExitOwnStock(): void {
    this.document.location.href = `${this.domainWithoutCid}${this.document.location.pathname}${this.document.location.search}`;
  }
}
